import NoteAddIcon from "@mui/icons-material/NoteAdd";
import { alpha, Paper, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import {
  Button,
  ImageFileProps,
  Spacer,
  Toolbar,
  useFilePicker,
} from "common";
import { useRef, useState } from "react";
import { Document, Page } from "react-pdf";

const useStyles = makeStyles((theme: any) => ({
  page: {
    "& canvas": {
      border: `solid 1px ${theme.palette.divider}`,
      width: "100% !important",
      maxWidth: "1024px",
      height: "auto !important",
    },
  },
}));

export default function DragDropFile({
  upload,
  uri,
  value,
  onChange,
  buttonSize = "small",
  readOnly,
  size = 56,
  fallBackComponent,
  fallBackImage,
  type,
  placeholder,
  helperText,
  isDirty,
  required,
  validate,
  onlyUploadButton,
  accept,
  stackProps,
  ...boxProps
}: ImageFileProps) {
  const classes = useStyles();
  const { file, downloadUrl, clearFile, onUploadButtonChange } = useFilePicker({
    value: value as any,
    uri,
    upload,
    //onChangeBase64: onChange,
    onChange: onChange,
    validate,
    useObjectValue: true,
  });
  // drag state
  const [dragActive, setDragActive] = useState(false);
  // ref
  const inputRef = useRef<HTMLInputElement>(null);

  const [pages, setPages] = useState<any[]>([]);

  // handle drag events
  const handleDrag = function (e: any) {
    e.preventDefault();
    e.stopPropagation();
    console.log("handleDrag");
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true);
    } else if (e.type === "dragleave") {
      setDragActive(false);
    }
  };

  // triggers when file is dropped
  const handleDrop = function (e: any) {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    console.log("handleDrop");
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      // handleFiles(e.dataTransfer.files);
      console.log(e.dataTransfer.files[0]);
      onUploadButtonChange(e.dataTransfer.files);
    }
  };

  // triggers when file is selected with click
  const handleChange = function (e: any) {
    console.log("handleChange");
    e.preventDefault();
    if (e.target.files && e.target.files[0]) {
      // handleFiles(e.target.files);
      console.log(e.target.files[0]);
      onUploadButtonChange(e.target.files);
    }
  };

  // triggers the input when the button is clicked
  const onButtonClick = () => {
    console.log("onButtonClick");
    inputRef.current?.click();
  };

  function handleLoadSuccess({ numPages, ...rest }: any) {
    //setLoading(false);
    if (pages.length !== numPages) {
      setPages([...new Array(numPages).fill(null)]);
    }
    console.log("handleLoadSuccess");
    //setPages([...new Array(numPages).fill(null)]);
  }

  function handleLoadError(error: any) {
    //setLoading(false);
    console.log("handleLoadError");
    setPages([]);
  }
  console.log({ pages, dragActive });
  return (
    <form onDragEnter={handleDrag} onSubmit={e => e.preventDefault()}>
      <input
        ref={inputRef}
        type="file"
        id="input-file-upload"
        multiple={true}
        onChange={handleChange}
        style={{ display: "none" }}
      />
      <Paper
        elevation={0}
        sx={{
          p: 3,
          display: "flex",
          flexDirection: "column",
          borderColor: "primary.main",
          borderWidth: 1,
          borderStyle: "dashed",
          position: "relative",
          overflow: "hidden",
          backgroundColor: theme =>
            dragActive
              ? alpha(theme.palette.primary.main, 0.4)
              : alpha(theme.palette.primary.main, 0.1),
        }}
        component="label"
        htmlFor="input-file-upload"
      >
        {!!file?.uri && (
          <Document
            //key={file?.uri}
            file={file?.uri}
            //options={options}
            /*options={
              {
                //httpHeaders: { "Cache-Control": "no-cache" },
                //withCredentials: true,
              }
            }*/
            onLoadSuccess={handleLoadSuccess}
            onLoadError={handleLoadError}
          >
            {pages.map((_p, index) => {
              return (
                //@ts-ignore
                <Page
                  key={`${index}`}
                  pageNumber={index + 1}
                  className={classes.page}
                  renderTextLayer={false}
                  renderAnnotationLayer={false}
                  width={595 * 2}
                  height={841 * 2}
                  //className={"pdf-modal-page" + (index > 0 ? " margin-top-2" : "")}
                />
              );
            })}
          </Document>
        )}
        <Toolbar>
          <NoteAddIcon sx={{ color: "primary.main" }} />
          <Spacer w={1} />
          <Typography color="primary.main" variant="body2">
            Drop your pdf here or
            <Button
              size="small"
              onClick={onButtonClick}
              variant="text"
              sx={{
                textDecorationLine: "underline",
                display: "inline",
                cursor: "pointer",
                textTransform: "none",
                fontSize: "0.875rem",
                fontWeight: 500,
                marginTop: "-2px",
                paddingLeft: "0px!important",
                paddingRight: "0px!important",
                padding: "0 0!important",
              }}
            >
              browse
            </Button>
          </Typography>
        </Toolbar>
        {dragActive && (
          <div
            id="drag-file-element"
            style={{
              position: "absolute",
              width: "100%",
              height: "100%",
              top: 0,
              right: 0,
              bottom: 0,
              left: 0,
            }}
            onDragEnter={handleDrag}
            onDragLeave={handleDrag}
            onDragOver={handleDrag}
            onDrop={handleDrop}
          ></div>
        )}
      </Paper>
    </form>
  );
}
